import { invitationActionTypes } from './invitation.types';

// VERIFY
export const invitationVerifyRequest = (token) => ({
    type: invitationActionTypes.INVITATION_VERIFY_REQUEST,
    payload: { token },
});
export const invitationVerifySuccess = (data) => ({
    type: invitationActionTypes.INVITATION_VERIFY_SUCCESS,
    payload: data,
});
// VERIFY: FAILURE — payload: { code, message }
export const invitationVerifyFailure = ({ code, message }) => ({
    type: invitationActionTypes.INVITATION_VERIFY_FAILURE,
    payload: { code, message },
});

// ACCEPT
export const invitationAcceptRequest = (token) => ({
    type: invitationActionTypes.INVITATION_ACCEPT_REQUEST,
    payload: { token },
});
export const invitationAcceptSuccess = () => ({
    type: invitationActionTypes.INVITATION_ACCEPT_SUCCESS,
});
// ACCEPT: FAILURE — payload: { code, message }
export const invitationAcceptFailure = ({ code, message }) => ({
    type: invitationActionTypes.INVITATION_ACCEPT_FAILURE,
    payload: { code, message },
});

// RESET
export const invitationReset = () => ({
    type: invitationActionTypes.INVITATION_RESET,
});
